class BxfCheckboxGroupConstants {
    static STRING = {
        INLINE: 'bxf-checkbox-group__header--inline',
        WRAPPER: 'bxf-checkbox-group-wrapper',
        BOLD: 'bxf-checkbox-group--bold',
        STACKED: 'bxf-checkbox-group--stacked',
        VERTICAL_CONTENT: 'bxf-checkbox-group__vertical-content',
        HORIZONTAL_CONTENT: 'bxf-checkbox-group__horizontal-content',
        VERTICAL_CONTENT_COMPACT: 'bxf-checkbox-group__vertical-content--compact',
        HORIZONTAL_CONTENT_COMPACT: 'bxf-checkbox-group__horizontal-content--compact',
        MENU_TYPE: 'bxf-checkbox-group__menu',
        MENU_ITEM_CHECKED: 'bxf-checkbox-group__menu-item--checked',
        CHECKBOX_HEADER: 'bxf-checkbox-group__header',
        CHECKBOX_HEADER_COMPACT: 'bxf-checkbox-group__header--compact',
        CHECKBOX_HEADER_BOLD: 'bxf-checkbox-group__header--bold',
        CHECKBOX_HEADER_FILTER_BAR: 'bxf-checkbox-group__header--filter-bar',
        REQUIRED_SYMBOL: 'bxf-checkbox-group__label--required',
        ERROR_MESSAGE_CLASS: 'bxf-checkbox-group__message--error',
        WARNING_MESSAGE_CLASS: 'bxf-checkbox-group__message--warning',
        CHECKBOX_ERROR_WRAPPER: 'bxf-checkbox-group-wrapper--error',
        CHECKBOX_WARNING_WRAPPER: 'bxf-checkbox-group-wrapper--warning',
        CHECKBOX_LABEL_WRAPPER: 'bxf-checkbox-group-wrapper__label',
        CHECKBOX_LABEL_WRAPPER_COMPACT: 'bxf-checkbox-group-wrapper__label--compact',
        VALIDATION_ERROR: 'bxf-checkbox-group__validation-error',
        DEFAULT_REQUIRED_VALIDATION_ERROR: 'At least one selection is required',
        SELECTION_REQUIRED_TEXT: 'selection required',
        SIZE_REGULAR: 'regular',
        DATA_LABEL: 'label',
        DATA_SECONDARY_LABEL: 'secondaryLabel',
        DATA_SECONDARY_LABEL_RIGHT: 'isSecondaryLabelRight',
        DATA_CHECKED: 'checked',
        DATA_DISABLED: 'disabled',
        DATA_UID: 'uid',
        DATA_MIXED: 'mixed',
        DATA_EVENT_DATA: 'eventData',
        ERROR_MESSAGE: 'Error Message',
        ASTERISK: '*',
        INSTRUCTIONAL_TEXT: 'bxf-checkbox-group__instructional-text',
        INSTRUCTIONAL_TEXT_COMPACT: 'bxf-checkbox-group__instructional-text--compact',
        CHECKBOX_HEADER_WITH_INSTRUCTIONAL_TEXT: 'bxf-checkbox-group__header--instructional-text',
    };
}

export { BxfCheckboxGroupConstants as B };
